// extracted by mini-css-extract-plugin
module.exports = {"s1rfmxz9":"s1rfmxz9"};